import { Component, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { filter, takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import * as moment from 'moment';
import * as _ from 'underscore';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { FilterPipe } from 'src/app/pipe/list-filter-pipe/list-filter-pipe';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { sweetAlert } from 'src/app/utils/swal';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';
import { AssistService } from 'src/app/service/assist-service/assist.service';
import { FleetService } from '../../fleet/fleet-service/fleet.service';

@Component({
  selector: 'app-gantt-chart',
  templateUrl: './gantt-chart.component.html',
  styleUrls: ['./gantt-chart.component.css']
})
export class GanttChartComponent implements OnInit, OnDestroy {
  driverList = [];
  user;
  isShowAllTrips = false;
  isAllowToHover = false;
  todayDate;
  skip = 0;
  driverTrips = {};
  allTrips = [];
  drivers = [];
  selectedDropdownIndex: any;
  toggleActionButtons: boolean = false;
  timeZone;
  search;
  stationManagerList = [];
  preStaffList = {};
  selectedServiceArea = '';
  filteredServiceAreas = [];
  serviceAreaList = [];
  preServiceAreas = {};
  selectedDriver;
  selectedStationManager;
  filteredDrivers = [];
  tripDetailModalObj;
  completedTripModalObj;
  isUnAssignEnabled = false;
  isCancelUnabled = false;
  showSlideFilter = false;
  showBreak = false;
  preDriverList = {};
  driverShift = false;
  corporateList = [];
  preCooperates = {};
  levelOfServiceList = [];
  preLevelOfServices = {};
  spaceTypeList = [];
  preSpaceTypes = {};
  filteredCorporates = [];
  filteredLevelOfService = [];
  filteredSpaceTypes = [];
  selectedSpaceType = '';
  selectedCooperate = '';
  selectedLOS = '';
  hoveredTrip = null;
  preAssistList
  status = "active";
  preFleetList;
  tripStatuses = [
    { label: 'Unassigned', status: 'pending', isChecked: false },
    { label: 'Assigned', status: 'hanging', isChecked: true },
    { label: 'En Route', status: 'onway', isChecked: false },
    { label: 'Arrived', status: 'arrived', isChecked: false },
    { label: 'In Progress', status: 'started', isChecked: false },
    { label: 'Completed', status: 'finished', isChecked: false },
    { label: 'Cancelled', status: 'cancelled', isChecked: false },
  ];
  isShowStatusDropdown = false;

  selectedDate: any;
  timeRange: any;
  scheduleTime:any;
  driverId;
  isRdispatcher = false;
  driversTimelines = {};
  isShowColorInformation = false;
  version = '1';

  constructor(
    private fleetService: FleetService,
    private assistService : AssistService,
    private driverService: DriversService,
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private staffService: StaffService,
    private serviceArea: ServiceAreasService,
    private corporateService : CorporateService,
    private levelOfServiceService : LevelOfServiceService
  ) { }


  ngOnInit(): void {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data
          this.timeZone = data.timeZone;
          this.todayDate = moment.tz(this.timeZone).startOf("day").toISOString(),
          this.timeRange = [moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(), moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString()];


          if (this.user.sRoles && this.user.sRoles === "rdispatcher") {
            this.selectedStationManager = [this.user.sId];
            this.isRdispatcher = true;
          }

          this.getDriverList();
        }
      });
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreaList = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        });
  }

  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDriverList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            if (this.isRdispatcher) {
              data = data.filter(item => item.stationManager === this.user.sId);
            }

            this.driverList = data;

            this.getStaffList();
            this.getServiceAreas();
            this.getCorporate();
            this.getLevelOfService();
            this.getFleetList();
            this.getSpaceTypes();
            this.getAssisData();
            this.getTrips();
            this.getDriversTimelines();
          }
        },
      );
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.levelOfServiceList = data;
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.spaceTypeList = data;
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getTrips() {
    let jobStatuses = [];
    this.tripStatuses.forEach(t => {
      if (t.isChecked) {
        if (t.status === 'hanging') {
          jobStatuses.push('offered');
          jobStatuses.push('accepted');
        } else {
          jobStatuses.push(t.status);
        }
      }
    })
    if(jobStatuses && !jobStatuses.length){
      return;
    }
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: 'manifest',
      date: this.timeRange,
      showBreak: this.showBreak,
      skip:this.skip,
      jobStatuses

    };
    this.assignTripService
      .getAssignList(object)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if(data){
            this.allTrips = [...data, ...this.allTrips];
          }
          if (data.length) {
            this.skip += data.length;
            this.getTrips();
          } else {
            this.skip = 0;
            this.isAllowToHover = true;
          }
          this.allTripsFilteration();

        })
      }

  allTripsFilteration(){
    this.drivers = [];
    this.stationManagerList = [];
    let serviceAreas = [];
    let cooperates = [];
    let levelOfServices = [];
    let spaceTypes = [];
    this.allTrips.forEach(trip => {
      if (trip.driver) {
        if (this.isRdispatcher) {
          if (trip.driver.stationManager === this.user.sId) {
            this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName, stationManager: trip.driver.stationManager });
          }
        } else {
          this.drivers.push({ _id: trip.driver._id, displayName: trip.driver.displayName, stationManager: trip.driver.stationManager });
        }
      }



      if (trip.driver && trip.driver.stationManager) {

        if (this.isRdispatcher) {
          if (trip.driver.stationManager === this.user.sId) {
            this.stationManagerList.push(trip.driver.stationManager);
          }

        } else {
          this.stationManagerList.push(trip.driver.stationManager);
        }

      }

      if (trip.serviceArea) {
        serviceAreas.push(trip.serviceArea);
      }
      if (trip.cooperate) {
        cooperates.push(trip.cooperate);
      }
      if (trip.los) {
        levelOfServices.push(trip.los);
      }

      if (trip.spaceType) {
        spaceTypes.push(trip.spaceType);
      }
    });

    this.drivers = _.uniq(this.drivers, '_id').sort();
    this.stationManagerList = _.uniq(this.stationManagerList).sort();
    cooperates = _.uniq(cooperates).sort();
    levelOfServices = _.uniq(levelOfServices).sort();
    spaceTypes = _.uniq(spaceTypes).sort();

    if (serviceAreas && serviceAreas.length) {
      this.filteredServiceAreas = this.serviceAreaList.filter(s => serviceAreas.includes(s._id));
    }
    if (cooperates && cooperates.length) {
      this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
    }

    if (levelOfServices && levelOfServices.length) {
      this.filteredLevelOfService = this.levelOfServiceList.filter(l => levelOfServices.includes(l._id));
    }

    if (spaceTypes && spaceTypes.length) {
      this.filteredSpaceTypes = this.spaceTypeList.filter(s => spaceTypes.includes(s._id));
    }
    this.filteredDrivers = this.drivers;

    this.filterTrips();
  }


  filterDriversbyStationManager() {
    this.filteredDrivers = []
    if (this.selectedStationManager && this.selectedStationManager.length) {
      this.filteredDrivers = this.drivers.filter(driver => {
        return this.selectedStationManager.includes(driver.stationManager);
      });
    } else {
      this.filteredDrivers = this.drivers;
    }
    this.filterTrips();
  }

  filterTrips() {

    let filterdataList = this.allTrips.filter(trip => trip.driver);

    filterdataList = filterdataList.filter(trip => {
      let isDriverExist = true;
      let isStaffExist = true;
      let isServiceAreaExist = true;
      let isCorporateExist = true;
      let islosExist = true;
      let isSpaceTypeExist = true;

      if (this.selectedDriver && this.selectedDriver.length) {
        isDriverExist = trip.driver && this.selectedDriver.includes(trip.driver._id);
      }

      if (this.selectedStationManager && this.selectedStationManager.length) {
        isStaffExist = trip.driver && trip.driver.stationManager && this.selectedStationManager.includes(trip.driver.stationManager);
      }

      if (this.selectedServiceArea && this.selectedServiceArea.length) {
        isServiceAreaExist = trip.serviceArea && this.selectedServiceArea.includes(trip.serviceArea);
      }

      if (this.selectedCooperate && this.selectedCooperate.length) {
        isCorporateExist = trip.cooperate && this.selectedCooperate.includes(trip.cooperate);
      }

      if (this.selectedLOS && this.selectedLOS.length) {
        islosExist = trip.los && this.selectedLOS.includes(trip.los);
      }

      if (this.selectedSpaceType && this.selectedSpaceType.length) {
        isSpaceTypeExist = trip.spaceType && this.selectedSpaceType.includes(trip.spaceType);
      }

      return isDriverExist && isStaffExist && isServiceAreaExist && isCorporateExist && islosExist && isSpaceTypeExist;
    });

      const unassignedTrips = this.allTrips.filter(trip => trip.status === 'unassigned');
      filterdataList = [...filterdataList, ...unassignedTrips];

    if (this.isCancelUnabled) {
      const cancelledTrips = this.allTrips.filter(trip => trip.status === 'cancelled');
      filterdataList = [...filterdataList, ...cancelledTrips];
    }

    const now = moment(this.todayDate).tz(this.timeZone);

    this.driverList.forEach(driver => {
      const currentShift = driver.shifts.find(s => s.isEnabled && s.day === now.day());
       driver.checkIn = Number.MAX_SAFE_INTEGER;

      if (currentShift) {
        const checkin = moment(currentShift.checkin, "HH:mm").tz(this.timeZone);
        driver.checkIn = checkin
        if ( driver.checkIn < 0) {
           driver.checkIn = Number.MAX_SAFE_INTEGER;
        }
      }
    });

    this.driverList = this.driverList.sort((a, b) => a.checkIn - b.checkIn);

    const groupedTrips = _.groupBy(
      filterdataList,
      trip => (trip.driver && trip.driver._id) || 'no_driver'
    );

    const dTrips = {};
    this.driverList.forEach(driver => {
      const trips = groupedTrips[driver._id]
      if (trips && trips.length) {
        // this.driverTrips[driver._id] = trips;
        dTrips[driver._id] = trips;
      }
    });
    this.driverTrips = dTrips;
    if(groupedTrips['no_driver']){
      this.driverTrips['no_driver'] = groupedTrips['no_driver'];
    }
  }

  getNumberOfDrivers() {
    return Object.keys(this.driverTrips).length;
  }

  getStartPoint(date, b) {
    let startinghoursPoint = moment(date).tz(this.timeZone).hours()  * 12;

    if (startinghoursPoint < 1) {
      startinghoursPoint = 1
    }

    if (b && startinghoursPoint < 1) {
      startinghoursPoint = 1;
    }

    const startingMinutesPoint = this.calculateMinutesValue(moment(date).tz(this.timeZone).minutes());
    return startinghoursPoint + startingMinutesPoint;

  }

  getEndPoint(dateOne, dateTwo) {
    // Define the two times
    const time1 = moment(dateOne).tz(this.timeZone);
    const time2 = moment(dateTwo).tz(this.timeZone);

    // Calculate the difference in minutes
    let diffInMinutes = time2.diff(time1, 'minutes');

    // Ensure the minimum value is 1 minute
    if (diffInMinutes < 1) {
      diffInMinutes = 1;
    }

    // Convert the difference to hours and minutes
    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;
    let res = this.getStartPoint(moment(`${hours}:${minutes.toString().padStart(2, '0')}`, 'HH:mm').toISOString(), false);

    if (time1.hours() < 1) {
      res -= 1;
    }

    return res;
  }


  getShiftStartPoint(date, b){
    const modifiedDate = moment(date, 'HH:mm').toISOString();
    let startinghoursPoint = moment(modifiedDate).tz(this.timeZone).hours() * 12;

    if (startinghoursPoint < 1) {
      startinghoursPoint = 1
    }

    if (b && startinghoursPoint < 1) {
      startinghoursPoint = 1;
    }

    const startingMinutesPoint = this.calculateMinutesValue(moment(modifiedDate).tz(this.timeZone).minutes());
    return startinghoursPoint + startingMinutesPoint;

  }


  getShiftEndPoint(dateOne, dateTwo) {
    // Define the two times
    const modifiedDate1 = moment(dateOne, 'HH:mm').toISOString();
    const modifiedDate2 = moment(dateTwo, 'HH:mm').toISOString();

    const time1 = moment(modifiedDate1).tz(this.timeZone);
    const time2 = moment(modifiedDate2).tz(this.timeZone);

    // Calculate the difference in minutes
    let diffInMinutes = time2.diff(time1, 'minutes');

    // Ensure the minimum value is 1 minute
    if (diffInMinutes < 1) {
      diffInMinutes = 1;
    }

    // Convert the difference to hours and minutes
    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;
    let res = this.getStartPoint(moment(`${hours}:${minutes.toString().padStart(2, '0')}`, 'HH:mm').toISOString(), false);

    if (time1.hours() < 1) {
      res -= 1;
    }
    return res;
  }

  calculateMinutesValue(value) {
    return Math.round(((value * 12) / 60));
  }

  openDetailModal(trip){
    this.tripDetailModalObj = trip
  }
  viewCompletedTripDetails(trip) {
    this.completedTripModalObj = trip;
  }

  refreshTrips() {
    this.skip = 0;
    this.isAllowToHover = false;
    this.allTrips = [];
    this.driverTrips = [];
    this.getTrips();
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  showDriverBreak(val){
    this.showBreak = val
    this.allTrips = [];
    this.driverTrips = [];
    this.getTrips();
  }

  currentDayShift(shifts) {
    const currentDay = moment(this.todayDate).tz(this.timeZone).day();
    if (shifts) {
      let shift = shifts.find(shift => shift.day === currentDay);
      return shift;
    } else {
      return {};
    }
  }

  onResetTime() {
    this.skip = 0;
    this.allTrips = [];
    this.driverTrips = [];
    this.timeRange = [
      moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(),
      moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString(),
    ]
    this.getTrips();
  }
  onTimeChange(event) {
    this.skip = 0;
    this.allTrips = [];
    this.driverTrips = [];
    this.driversTimelines = {};
    // debugger;
    this.timeRange = [event[0].toISOString(), event[1].toISOString()];
    this.getTrips();
  }

  onDateChange(event) {
    this.skip = 0;
    this.allTrips = [];
    this.driverTrips = [];
    this.todayDate = event.toISOString();
    this.timeRange = [event.toISOString(), event.endOf("day").toISOString()];
    this.driversTimelines = {};
    // this.todayDate =
    //   [
    //     event[0].toISOString(),
    //     event[1].endOf("day").toISOString(),
    //   ]
    this.isAllowToHover = false;
    this.getTrips();
    this.getDriversTimelines();
  }

  getTimeRestrictions() {
      return { min: moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(), max: moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString() }
  }

  getAssisData(){
    this.assistService.getAllAssists()
    .pipe(takeUntil(takeUntilDestroyed(this)))
    .subscribe(data => {
      if (data) {
        // this.assists = data;
        this.preAssistList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

      }
    });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({'isFleetSection': true,'status': this.status})
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleetList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  toggleStatusDropdown() {
    this.isShowStatusDropdown = !this.isShowStatusDropdown
  }

  onChangeStatus() {
    this.isAllowToHover = false;
    this.skip = 0;
    this.allTrips = [];
    this.driverTrips = [];
    this.getTrips();
  }

  sortMethod() {
    return 0;
  }
  createTrip(event: MouseEvent) {

    const startingPoint = document.getElementById('startingPoint');

    if (!startingPoint) {
      return;
    }

    const gridWidth = startingPoint.offsetWidth;
    const gridHeight = startingPoint.offsetHeight;

    const totalColumns = 288;
    const totalRows = this.getNumberOfDrivers();

    const columnWidth = gridWidth / totalColumns;
    const rowHeight = gridHeight / totalRows;

    const rect = startingPoint.getBoundingClientRect();

    const clickX = event.clientX - rect.left;
    const clickY = event.clientY - rect.top;

    const clickedColumn = Math.floor(clickX / columnWidth) + 1;
    const clickedRow = Math.floor(clickY / rowHeight) + 1;

    const rowIndex = clickedRow - 1;
    const driverIds = Object.keys(this.driverTrips)
    const driverId = driverIds[rowIndex]
    const minutesPerColumn = 5;
    const startTime = moment().startOf('day');

    const totalMinutes = (clickedColumn - 1) * minutesPerColumn;

    const clickedTime = startTime.clone().add(totalMinutes, 'minutes');

    const scheduleTime = clickedTime.tz(this.timeZone);
    this.scheduleTime = scheduleTime;
    this.driverId = driverId && driverId === 'no_driver' ? undefined : driverId;
  }


  onEditTrip(trip) {
    if (trip) {
      trip.driver = this.driverList.find(driver=> driver._id === trip.driver);
      this.allTrips.push(trip);
      this.allTripsFilteration();
      this.scheduleTime = null;
      this.driverId = null;
    }
  }

  getDriversTimelines() {
    const queryString = {};
    const range = [moment(this.todayDate).startOf("day").toISOString(), moment(this.todayDate).endOf("day").toISOString()];
    queryString['dates'] = { "startDate": range[0], "endDate": range[1] };
    this.driverService
      .getAllDriverTimelines(queryString)
      .subscribe(data => {
        if (data && data.length) {
          this.driversTimelines = data.reduce((acc, item) => {
            const {_id, jobs} = item;
            const driverId = _id.driver;
            acc[driverId] = {
              checkin: jobs && jobs.length ? jobs[0].checkin : null,
              checkout: jobs && jobs.length ? jobs[0].checkout : null
            }
            return acc;
          }, {});
          console.log(this.driversTimelines);
        }
      });
  }

  shiftBreakdown(driverId) {
    const shift = this.driversTimelines[driverId];
    const driverTrips = this.driverTrips[driverId];
    if (!(shift && driverTrips && driverTrips.length)) return;

    let breakdown = {};
    let { checkin, checkout } = shift;
    if (checkin && !checkout) {
      const lastTrip = driverTrips && driverTrips.length ? driverTrips[driverTrips.length - 1] : null;

      const checkinHours = moment(checkin).tz(this.timeZone).format("HH:mm");
      const supposedCheckout = moment(checkin).tz(this.timeZone).add(8, 'hours');
      const supposedCheckoutHours = supposedCheckout.format("HH:mm");

      const apt = moment(lastTrip.appointmentTime).tz(this.timeZone);
      const aptHours = apt.format("HH:mm");

      breakdown['shift_started.regular_window'] = {
        start: this.getShiftStartPoint(checkinHours, true),
        end: this.getShiftEndPoint(checkinHours, supposedCheckoutHours)
      };

      if (apt.isAfter(supposedCheckout)) {
        breakdown['shift_started.overtime_window'] = {
          start: this.getShiftStartPoint(supposedCheckoutHours, true),
          end: this.getShiftEndPoint(supposedCheckoutHours, aptHours)
        }
      }
      return breakdown;
    } else if (checkin && checkout) {
      const checkinMoment = moment(checkin).tz(this.timeZone);
      const checkoutMoment = moment(checkout).tz(this.timeZone);

      const totalHoursWorked = checkoutMoment.diff(checkinMoment, 'hours', true);
      const checkinHours = checkinMoment.format("HH:mm");
      const checkoutHours = checkoutMoment.format("HH:mm");

      if (totalHoursWorked > 8) {
        const regularShiftEndHours = checkinMoment.add(8, 'hours').format('HH:mm');
        breakdown['shift_ended.regular_window'] = {
          start: this.getShiftStartPoint(checkinHours, true),
          end: this.getShiftEndPoint(checkinHours, regularShiftEndHours)
        }
        breakdown['shift_ended.overtime_window'] = {
          start: this.getShiftStartPoint(regularShiftEndHours, true),
          end: this.getShiftEndPoint(regularShiftEndHours, checkoutHours)
        }
      } else {
        breakdown['shift_ended.regular_window'] = {
          start: this.getShiftStartPoint(checkinHours, true),
          end: this.getShiftEndPoint(checkinHours, checkoutHours)
        }
      }

      return breakdown;
    }
  }

  trackById(index: number, item: any): number {
    return item.key;
  }

  ngOnDestroy(): void {

  }
}


